import { useRef, useState } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { useMutation } from '@apollo/client';
import { IContactPhone } from '../../../../types/contact';
import { notifySuccess } from '../../../../services/notification';
import { CancelIcon, SaveIcon } from '../../../common/icons';
import SpinnerOverlay from '../../../common/spinner/spinner';
import PhoneDetails, { PhoneHandler } from '../../../org/contact-info/org-phone/phone-details';
import { GET_POSITION_CONTACT_PHONES, UPDATE_POSITION_CONTACT_PHONE } from '../../../../graphql/contact-gql';
import Button from '../../../common/button';

type PhoneUpdateProps = {
    isOpen: boolean;
    toggle: () => void;
    contactPhone?: IContactPhone;
    isRole: boolean;
}

const PhoneUpdate = (props: PhoneUpdateProps) => {
    const { isOpen, toggle, contactPhone, isRole } = props
    const contactRef = useRef<PhoneHandler>(null)

    const [updateContactPhone, {loading}] = useMutation(UPDATE_POSITION_CONTACT_PHONE)

    const [validated, setValidated] = useState<boolean>(true)

    const saveContact = () => {
        if (contactRef.current && !contactRef.current.validate(true)) {
            setValidated(false)
            return
        }

        let contactPhoneInput = contactRef.current && contactRef.current.getContactPhone()

        updateContactPhone({
            variables: {
                positionId: contactPhone?.businessEntityId,
                input: contactPhoneInput
            },
            refetchQueries: [{
                query: GET_POSITION_CONTACT_PHONES,
                variables: { positionId: contactPhone?.businessEntityId }
            }],
            awaitRefetchQueries: true,
            onCompleted: (data) => {
                toggle()
                data && notifySuccess()
            }
        })
    }

    const onChange = () => {
        setValidated(!!contactRef.current?.validate(false))
    }

    return (<>
        {loading && <SpinnerOverlay />}
        <Modal size="lg" isOpen={isOpen} toggle={toggle} scrollable backdrop="static" autoFocus={false}>
            <ModalHeader toggle={toggle} tag={'h2'}>Update a {isRole ? 'Role' : 'Position'} Phone Number</ModalHeader>
            <ModalBody>
                <PhoneDetails ref={contactRef} isOrgPhone={false} contactPhone={contactPhone} onChange={onChange} autoFocus={true} />
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={saveContact} disabled={!validated}><SaveIcon/> Update</Button>
                <Button color="secondary" onClick={toggle}><CancelIcon/> Cancel</Button>
            </ModalFooter>
        </Modal>
        </>
    )
}

export default PhoneUpdate
